import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import 'flag-icons/css/flag-icons.min.css';
import './styles.css';
import './interparcel-design.css';
import './compact-business.css';
import './dashboard.css';
import './reports.css';
import './ui-components.css';
import './app-theme.css';
import './ui-standards-rollout.css';

const root = document.getElementById('root');

if (!root) {
	throw new Error('Application root element was not found');
}

createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
